import React, { useState } from "react";
import { Box, Typography, Button, Grid, TextField, Alert } from "@mui/material";
import { useParams } from "react-router-dom";

// Sample hats data with 10 different hats
const hats = [
  {
    id: 1,
    name: "Baseball Cap",
    price: 15,
    image: "/baseball-cap.jpg",
    description:
      "A classic and casual cap, perfect for everyday wear and outdoor activities.",
  },
  {
    id: 2,
    name: "Fedora",
    price: 20,
    image: "/baseball-cap.jpg",
    description:
      "A stylish hat with a pinched crown and wide brim, adding a touch of elegance to any outfit.",
  },
  {
    id: 3,
    name: "Beanie",
    price: 10,
    image: "/baseball-cap.jpg",
    description:
      "A soft, warm hat ideal for colder weather, keeping your head cozy and comfortable.",
  },
  {
    id: 4,
    name: "Trucker Hat",
    price: 18,
    image: "/baseball-cap.jpg",
    description:
      "A breathable hat with a mesh back, designed for both style and functionality.",
  },
  {
    id: 5,
    name: "Bucket Hat",
    price: 12,
    image: "/baseball-cap.jpg",
    description:
      "A casual hat with a downward-sloping brim, offering great sun protection and a laid-back look.",
  },
  {
    id: 6,
    name: "Panama Hat",
    price: 25,
    image: "/baseball-cap.jpg",
    description:
      "A lightweight, woven hat, perfect for warm climates and beach vacations.",
  },
  {
    id: 7,
    name: "Visor",
    price: 8,
    image: "/baseball-cap.jpg",
    description:
      "A sun-blocking headpiece with an open top, great for sports and outdoor activities.",
  },
  {
    id: 8,
    name: "Snapback",
    price: 22,
    image: "/baseball-cap.jpg",
    description:
      "A structured cap with an adjustable snap closure, a favorite among streetwear enthusiasts.",
  },
  {
    id: 9,
    name: "Bowler Hat",
    price: 30,
    image: "/baseball-cap.jpg",
    description:
      "A round, hard-felt hat with a short brim, exuding a classic and vintage charm.",
  },
];
const colors = ["red", "blue", "green", "yellow", "purple"];

const HatDetailPage = ({ addToBag }) => {
  const { id } = useParams();
  const hat = hats.find((hat) => hat.id === parseInt(id));

  const [selectedColor, setSelectedColor] = useState(null);
  const [quantity, setQuantity] = useState(1);
  const [addedToBag, setAddedToBag] = useState(false);

  if (!hat) return <Typography variant="h6">Hat not found</Typography>;

  const handleAddToBag = () => {
    if (selectedColor) {
      addToBag(hat, quantity, selectedColor);
      setAddedToBag(true);

      // Hide confirmation message after 2 seconds
      setTimeout(() => setAddedToBag(false), 2000);
    }
  };

  return (
    <Box sx={{ padding: 4 }}>
      <Grid container spacing={4}>
        <Grid
          item
          xs={12}
          md={6}
          sx={{ display: "flex", justifyContent: "center" }}
        >
          <img
            src={hat.image}
            alt={hat.name}
            style={{ width: "80%", borderRadius: "10px" }}
          />
        </Grid>

        <Grid item xs={12} md={6}>
          <Typography variant="h4" gutterBottom>
            {hat.name}
          </Typography>
          <Typography variant="h6" sx={{ mt: 2 }}>
            Price: ${hat.price}
          </Typography>

          {/* Color Picker */}
          <Typography variant="body1" sx={{ mt: 3 }}>
            Select Color:
          </Typography>
          <Box sx={{ display: "flex", gap: 2, mt: 1 }}>
            {colors.map((color) => (
              <Button
                key={color}
                sx={{
                  width: 30,
                  height: 30,
                  minWidth: 0,
                  borderRadius: "50%",
                  backgroundColor: color,
                  border: selectedColor === color ? "3px solid black" : "none",
                  "&:hover": { opacity: 0.8 },
                }}
                onClick={() => setSelectedColor(color)}
              />
            ))}
          </Box>

          {/* Quantity Input */}
          <Typography variant="body1" sx={{ mt: 3 }}>
            Quantity:
          </Typography>
          <TextField
            type="number"
            value={quantity}
            onChange={(e) =>
              setQuantity(Math.max(1, parseInt(e.target.value) || 1))
            }
            inputProps={{ min: 1 }}
            sx={{ mt: 1, width: "100px" }}
          />

          {/* Total Price */}
          <Typography variant="h6" sx={{ mt: 3 }}>
            Total: ${hat.price * quantity}
          </Typography>

          {/* Confirmation Message */}
          {addedToBag && (
            <Alert severity="success" sx={{ mt: 2 }}>
              Added to bag!
            </Alert>
          )}

          {/* Add to Bag Button */}
          <Button
            variant="contained"
            color="primary"
            sx={{ mt: 3 }}
            disabled={!selectedColor}
            onClick={handleAddToBag}
          >
            Add to Bag
          </Button>
        </Grid>
      </Grid>
    </Box>
  );
};

export default HatDetailPage;
